import { stopSavingQueries } from './offlineQueryCache';
import { deleteOfflineStore } from './offlineStore';

/**
 * The service worker's (apps/work-permit/public/sw.js) caches holding the
 * user's pages and session. Matched by prefix so a bumped cache version is
 * still cleared. Its JS/CSS and offline-page caches hold nothing user-specific
 * and are kept.
 */
const USER_CACHE_PREFIX = 'insafe-user-';

async function deleteUserCaches(): Promise<void> {
  if (typeof caches === 'undefined') {
    return;
  }
  const names = await caches.keys();
  await Promise.all(
    names
      .filter((name) => name.startsWith(USER_CACHE_PREFIX))
      .map((name) => caches.delete(name)),
  );
}

/**
 * Deletes everything kept on the device for offline use: saved pages, the
 * saved session and saved query data. Called on sign-out, so none of it
 * outlives the session on a shared device.
 *
 * Never throws: sign-out must not fail on missing or blocked storage.
 */
export async function clearOfflineData(): Promise<void> {
  stopSavingQueries();
  await Promise.all([
    deleteUserCaches().catch(() => undefined),
    deleteOfflineStore(),
  ]);
}
